/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface ContactScriptManifest
 */
export interface ContactScriptManifest {
    /**
     * 
     * @type {number}
     * @memberof ContactScriptManifest
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ContactScriptManifest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactScriptManifest
     */
    source?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactScriptManifest
     */
    trigger?: string;
    /**
     * 
     * @type {Date}
     * @memberof ContactScriptManifest
     */
    createdDate?: Date;
}

/**
 * Check if a given object implements the ContactScriptManifest interface.
 */
export function instanceOfContactScriptManifest(value: object): boolean {
    return true;
}

export function ContactScriptManifestFromJSON(json: any): ContactScriptManifest {
    return ContactScriptManifestFromJSONTyped(json, false);
}

export function ContactScriptManifestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactScriptManifest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'source': json['source'] == null ? undefined : json['source'],
        'trigger': json['trigger'] == null ? undefined : json['trigger'],
        'createdDate': json['createdDate'] == null ? undefined : (new Date(json['createdDate'])),
    };
}

export function ContactScriptManifestToJSON(value?: ContactScriptManifest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'source': value['source'],
        'trigger': value['trigger'],
        'createdDate': value['createdDate'] == null ? undefined : ((value['createdDate']).toISOString()),
    };
}

